import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { FEATURE_DO_IT_LATER_INTAKE_ACTION, FEATURE_ENABLE_TODO_DISCOVERY, FEATURE_ENABLE_RECURRING_TODOS, FEATURE_ENABLE_GUIDE_DEPRECATION, FEATURE_EXTEND_PROPOSAL_SHARING, FEATURE_SWAP_PROPOSAL_CTAS, FEATURE_UPDATE_MEMBER_TODO_FEEDBACK, FEATURE_ONBOARDING_2_2, FEATURE_PRIME_PRO_PREVIEW, FEATURE_PREVENT_TODO_HANDOFF_IF_MAX_REACHED, FEATURE_ENABLE_USE_TASK_DISPLAYNAME_INSTEAD_OF_NAME, FEATURE_ENABLE_REMOVAL_SKIP_ONE_TIME_CTA, FEATURE_3DS } from '@poplar/constants/split';
import { shoeboxFactory } from '@yoweb/ui/contexts/shoeboxFactory';
import { withPoplarI18n } from '@poplar/lib/server/i18n';

var _shoeboxFactory = shoeboxFactory('externalConfig'),
    Provider = _shoeboxFactory.Provider,
    createShoeboxStateWrapper = _shoeboxFactory.createShoeboxStateWrapper,
    ExternalConfigShoebox = _shoeboxFactory.Element,
    useExternalConfig = _shoeboxFactory.useShoebox;

export { Provider, createShoeboxStateWrapper, ExternalConfigShoebox, useExternalConfig };

var fetchFallbackI18nState = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
    var withPoplarI18nResult, defaultAppStateResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return withPoplarI18n(ctx, {
              ns: ['common']
            });

          case 2:
            withPoplarI18nResult = _context.sent;
            defaultAppStateResponse = {
              fallbackI18nextInitOptions: withPoplarI18nResult.props.i18nextPageResponse.config
            };
            return _context.abrupt("return", defaultAppStateResponse);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFallbackI18nState(_x) {
    return _ref.apply(this, arguments);
  };
}(); // *Note*: the return value of this function is serialized to the client bundle on
// every single page sent to client within _app
//
// Do not return any values from this object that you would consider private
// or internal. This is for global state that is intended to be seen externally.
//
// Also, extend the return value as a last resort - when page props do not suffice for passing
// down a configuration value.


export var createPoplarExternalConfigState = createShoeboxStateWrapper( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ctx) {
    var _featureResponse$prop;

    var _yield$Promise$all, _yield$Promise$all2, withFeature, privateRuntimeConfig, _yield$Promise$all3, _yield$Promise$all4, initialUserState, featureResponse, treatments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all([import('@poplar/lib/server/composables/withFeature'), import('@poplar/lib/server/privateRuntimeConfig')]);

          case 2:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            withFeature = _yield$Promise$all2[0].withFeature;
            privateRuntimeConfig = _yield$Promise$all2[1].privateRuntimeConfig;
            _context2.next = 8;
            return Promise.all([fetchFallbackI18nState(ctx), withFeature([FEATURE_DO_IT_LATER_INTAKE_ACTION, FEATURE_ENABLE_TODO_DISCOVERY, FEATURE_ENABLE_RECURRING_TODOS, FEATURE_ENABLE_GUIDE_DEPRECATION, FEATURE_EXTEND_PROPOSAL_SHARING, FEATURE_SWAP_PROPOSAL_CTAS, FEATURE_UPDATE_MEMBER_TODO_FEEDBACK, FEATURE_ONBOARDING_2_2, FEATURE_PRIME_PRO_PREVIEW, FEATURE_PREVENT_TODO_HANDOFF_IF_MAX_REACHED, FEATURE_ENABLE_USE_TASK_DISPLAYNAME_INSTEAD_OF_NAME, FEATURE_ENABLE_REMOVAL_SKIP_ONE_TIME_CTA, FEATURE_3DS], {
              passThrough: true
            })(ctx)]);

          case 8:
            _yield$Promise$all3 = _context2.sent;
            _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
            initialUserState = _yield$Promise$all4[0];
            featureResponse = _yield$Promise$all4[1];
            treatments = 'props' in featureResponse ? (_featureResponse$prop = featureResponse.props) === null || _featureResponse$prop === void 0 ? void 0 : _featureResponse$prop.treatments : {};
            return _context2.abrupt("return", _objectSpread(_objectSpread({}, initialUserState), {}, {
              appleAppId: privateRuntimeConfig.appleAppId,
              baseUrl: privateRuntimeConfig.baseURL(),
              baseUsUrl: privateRuntimeConfig.baseUsURL(),
              baseJpUrl: privateRuntimeConfig.baseJpURL(),
              baseStoreUrl: privateRuntimeConfig.baseStoreURL(),
              baseStoreUsURL: privateRuntimeConfig.baseStoreUsURL(),
              baseStoreJpURL: privateRuntimeConfig.baseStoreJpURL(),
              datadog: {
                applicationId: privateRuntimeConfig.datadog.applicationId(),
                clientToken: privateRuntimeConfig.datadog.clientToken(),
                disabled: !!privateRuntimeConfig.datadog.disabled,
                site: privateRuntimeConfig.datadog.site()
              },
              env: privateRuntimeConfig.env(),
              places: {
                publicKey: privateRuntimeConfig.places.publicKey()
              },
              prismic: {
                repository: privateRuntimeConfig.prismic()
              },
              stripe: {
                publicKey: privateRuntimeConfig.stripe.publicKey()
              },
              mixpanel: {
                requireCookie: !!privateRuntimeConfig.mixpanel.requireCookie,
                token: privateRuntimeConfig.mixpanel.token(),
                proxyUrl: privateRuntimeConfig.mixpanel.proxyUrl(),
                domain: privateRuntimeConfig.mixpanel.domain
              },
              appUrls: {
                apple: privateRuntimeConfig.appleStoreAppUrl(),
                android: privateRuntimeConfig.androidAppUrl()
              },
              braze: {
                apiKey: privateRuntimeConfig.braze.apiKey,
                baseUrl: privateRuntimeConfig.braze.baseUrl
              },
              globalFeatures: {
                enableDoThisLater: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_DO_IT_LATER_INTAKE_ACTION]) === 'on',
                enableTodoDiscovery: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_ENABLE_TODO_DISCOVERY]) === 'on',
                enableRecuringTodos: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_ENABLE_RECURRING_TODOS]) === 'on',
                enableGuideDeprecation: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_ENABLE_GUIDE_DEPRECATION]) === 'on',
                enableExtendedProposalSharing: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_EXTEND_PROPOSAL_SHARING]) === 'on',
                enablePurchaseProposalCtaSwap: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_SWAP_PROPOSAL_CTAS]) === 'on',
                enableUpdateMemberFeedback: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_UPDATE_MEMBER_TODO_FEEDBACK]) === 'on',
                enableOnboarding2_2: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_ONBOARDING_2_2]) === 'on',
                enablePrimeProPreview: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_PRIME_PRO_PREVIEW]) === 'on',
                enablePreventTodoHandoffIfMaxReached: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_PREVENT_TODO_HANDOFF_IF_MAX_REACHED]) === 'on',
                enableUseTaskDisplayNameInsteadOfName: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_ENABLE_USE_TASK_DISPLAYNAME_INSTEAD_OF_NAME]) === 'on',
                enableRemovalSkipOneTimeCta: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_ENABLE_REMOVAL_SKIP_ONE_TIME_CTA]) === 'on',
                enable3ds: (treatments === null || treatments === void 0 ? void 0 : treatments[FEATURE_3DS]) === 'on'
              }
            }));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}());